import React from 'react'
import { Link } from 'react-router-dom'
import { ReactComponent as LogoIcon } from '../../../assets/icons/logo.svg'
import { useAppSelector } from '../../../hooks/useAppSelector'

const Logo = () => {
	const { isAuth } = useAppSelector((state) => state.auth)

	return (
		<Link to={isAuth ? '/' : '/sign-in'}>
			<LogoIcon />
		</Link>
	)
}

export default Logo
